import { Component, ViewChild, TemplateRef, Input, ElementRef, Renderer2, OnInit, OnDestroy, OnChanges, AfterViewInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { qmsService } from '../qms.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { EditorConfig } from 'ngx-simple-text-editor';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-tasks-ec-actions',
  templateUrl: './tasks-ec-actions.component.html',
  styleUrls: ['./tasks-ec-actions.component.scss']
})

export class TasksEcActionsComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  @Input() effectivenessCheckData: any = {};
  @Input() refresh: boolean;
  isProcessing = false;
  module: any;
  refNo: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  isFrozen: boolean = false;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, private readonly sanitizer: DomSanitizer,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, public qmsservice: qmsService, private readonly renderer: Renderer2) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.module = this.qmsservice.moduleName;
    this.refNo = this.message.ecMasterDetails.REF_NO;
  }
  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  groupSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  dropDownDataForMethodology: any = [];
  dropDownForActionName: any = [];
  getQmsTaskActionsVwDetails: any = [];

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.isFrozen = this.effectivenessCheckData.showSubTaskButtons;
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("EFFECTIVENESS_CHECK_METHODOLOGY").subscribe(
      (data: any) => {
        this.dropDownDataForMethodology = data;
        this.selectBoxForMethodology();
      });
    if (this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items") {
      this.appService.getQmsActionByRefNo(this.refNo).subscribe(
        (data: any) => {
          this.getQmsTaskActionsVwDetails = data;
          this.getQmsTaskActionsVwDetails.forEach((actionData: any = []) => {
            if (!this.dropDownForActionName.some((tempData: any = []) => tempData.actionName === actionData.actionName)) {
              this.dropDownForActionName.push(actionData);
            }
          });
          this.isProcessing = false;
          this.selectBoxForActionName();
        });
    } else {
      this.appService.getAllPreActionByRefNo(this.refNo).subscribe((preAction: any) => {
        this.getQmsTaskActionsVwDetails = preAction;
        this.getQmsTaskActionsVwDetails.forEach((actionData: any = []) => {
          if (!this.dropDownForActionName.some((tempData: any = []) => tempData.actionName === actionData.actionName)) {
            this.dropDownForActionName.push(actionData);
          }
        });
        this.isProcessing = false;
        this.selectBoxForActionName();
      })
    }
    this.getcallMethod();
  }

  refreshForm() {
    this.getcallMethod();
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  qmsTasksECDetailsDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  ECPerformer: boolean;
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.qmsTasksECDetailsDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.qmsTasksECDetailsDataForGrid
      .slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.isProcessing = false;
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.qmsTasksECDetailsDataForGrid = [];

    const data = {

      gridName: "EC_ACTION",
      groupId: 0
    };
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_TASK_ACTION_EC_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? '',
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          refNoFromEffectivenessCheckDetail: this.refNo,
          ecIdFromECMasterPage: this.message.ecMasterDetails.EC_ID,
          ecActionsFor: this.message.ecMasterDetails.CHECK_REQD_FOR.includes('Pre') ? 'PreAction' : 'Action',
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.qmsTasksECDetailsDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const element of this.qmsTasksECDetailsDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    element[dataType.columnName] = element[dataType.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.labelcall();
              this.setPage(1, 0);
            });

            this.ngOnChanges();
            this.message.gridList = this.qmsTasksECDetailsDataForGrid;
            this.collectionSize = this.qmsTasksECDetailsDataForGrid.length;
            this.totalPages = Math.ceil(this.qmsTasksECDetailsDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.dynamicLabel = null;
    this.label = [];
    this.dynamicLabel = null;
    let data = {
      gridName: this.reportObj.gridName,
      tableName: this.reportObj.tableOrViewName,
      moduleName: this.qmsservice.moduleName,
      groupId: this.qmsservice.selectedGroup,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        return this.dynamicLabel
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  displayEditIconOnly: boolean = false;
  showConclusion: boolean;
  makeEnableEffectivenessCheckActionFields: boolean;
  ngOnChanges() {
    if (this.qmsservice.userRole[0].qmsRoles.includes("Effectiveness Check Performer") &&
      (this.effectivenessCheckData.status == 'Planning' || this.effectivenessCheckData.status == 'Approval Rejected')) {
      this.ECPerformer = true;
    } else {
      this.ECPerformer = false;
    }

    if (this.effectivenessCheckData.status == 'Pending Approval' || this.effectivenessCheckData.status == 'In Progress' || this.effectivenessCheckData.status == 'Closed' ||
      this.effectivenessCheckData.status == 'Pending QA Approval' || this.effectivenessCheckData.status == 'QA Approval Rejected' ||
      this.effectivenessCheckData.status == 'QA Approved') {
      this.makeEnableEffectivenessCheckActionFields = true;
      this.displayEditIconOnly = false;
    }

    if ((this.effectivenessCheckData.status == 'QA Approval Rejected' || this.effectivenessCheckData.status == 'In Progress') && this.qmsservice.userRole[0].qmsRoles.includes("Effectiveness Check Performer")) {
      this.makeEnableEffectivenessCheckActionFields = false;
      this.showConclusion = true;
      this.ECPerformer = false;
      this.displayEditIconOnly = true;
    }

    this.refresh = false;
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.qmsTasksECDetailsDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.qmsTasksECDetailsDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  sortedColumn: string = '';
  sortedDisplayColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    this.isProcessing = true;
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortedDisplayColumn = list.fieldColumnarray;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.qmsTasksECDetailsDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.qmsTasksECDetailsDataForGrid) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (const element of this.qmsTasksECDetailsDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  selectedMethodology: any = null;
  methodologyListDropdown: any = [];
  selectBoxForMethodology() {
    this.methodologyListDropdown = [];
    for (const element of this.dropDownDataForMethodology) {
      this.methodologyListDropdown = this.methodologyListDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
  }

  selectedActionName: any = null;
  actionNameListDropdown: any = [];
  selectBoxForActionName() {
    this.actionNameListDropdown = [];
    for (const element of this.dropDownForActionName) {
      this.actionNameListDropdown = this.actionNameListDropdown.concat({
        valueExp: element.actionId,
        displayExp: element.actionName
      });
    }
  }

  onActionsSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.actionNameValueRequired != undefined) {
        this.actionNameValueRequired.style.color = '';
      }
    }
  }

  onActionsRemoved(item: any) {
    if (this.actionNameValueRequired != undefined) {
      this.actionNameValueRequired.style.color = 'red';
    }
  }

  onMethodologySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (this.methodologyValueRequired != undefined) {
          this.methodologyValueRequired.style.color = '';
        }
      }
    }
  }

  onMethodologyRemoved(item: any) {
    if (this.methodologyValueRequired != undefined) {
      this.methodologyValueRequired.style.color = 'red';
    }
  }

  editorConfiguration: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '100px',
    minHeight: '100px',
    maxHeight: '400px',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: '',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [['undo', 'redo'],
    ['insertImage',
      'insertVideo',
      'toggleEditorMode']]
  };

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  config: EditorConfig = {
    //placeholder: 'Type something...',
    buttons: [],
    // height: '100px',
  };

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: any;

  // Extendable field mapping for different data sources
  private readonly editorFieldMapping: Record<string, any> = {
    'Criteria': () => this.ecActionsData.criteria,
    'Conclusion': () => this.ecActionsData.conclusion,
  };

  private readonly editorSaveMapping: Record<string, (val: any) => void> = {
    'Criteria': (val: any) => this.ecActionsData.criteria = val,
    'Conclusion': (val: any) => this.ecActionsData.conclusion = val,
  };

  public openEditor(value: string, icon?: string): void {
    this.allowEditing = icon === 'edit';
    this.editorName = value;

    // Try dynamicLabel mapping first
    const editorTitleMapping: Record<string, any> = {
      'Criteria': this.dynamicLabel?.['CRITERIA']?.fieldName,
      'Conclusion': this.dynamicLabel?.['CONCLUSION']?.fieldName,
    };

    this.editorTitle = editorTitleMapping[value] || value;

    const modelKey = this.getModel(this.editorTitle);

    // Decide which value to load
    if (this.editorFieldMapping[value]) {
      this.editorValue = this.editorFieldMapping[value](); // Criteria / Conclusion case
    } else {
      this.editorValue = this.ecActionsData[modelKey] || '';
    }

    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(): void {
    const modelKey = this.getModel(this.editorTitle);

    if (this.editorSaveMapping[this.editorName]) {
      this.editorSaveMapping[this.editorName](this.editorValue); // Criteria / Conclusion case
    } else {
      this.ecActionsData[modelKey] = this.editorValue;
    }

    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value
      .split(' ')
      .map((word: string, index: number) =>
        index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  }

  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;

  visibleEditor: MatDialogRef<TemplateRef<any>>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  operationFlag: any;
  ecActionsData: any = {};
  openAddPopup() {
    this.popupDataTitle.title = "Create Effectiveness Check " + (this.message.ecMasterDetails.CHECK_REQD_FOR.includes('Pre') ? 'Preliminary ' : '') + 'Action';
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.Showaddedit = true;
    this.operationFlag = 'ADD';
    this.selectedActionName = null;
    this.selectedMethodology = null;
    this.ecActionsData.criteria = "";
    this.ecActionsData.conclusion = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  previousDataEcId: any;
  previousDataActionEcId: any;
  getQmsTaskEcActionVwDetailData: any = [];
  filteredMethodologyValue: any = [];
  filteredActionValue: any = [];
  Showaddedit: boolean;
  openEditPopup(ecActionRowData: any, type: any, idx: any) {
    if (type == 'EDIT') {
      this.Showaddedit = true;
      if (this.effectivenessCheckData.status == 'Closed') {
        this.makeEnableEffectivenessCheckActionFields = true;
      }
    } else {
      this.Showaddedit = false;
    }
    const x = (this.message.ecMasterDetails.CHECK_REQD_FOR.includes('Pre') ? 'Preliminary ' : '') + 'Action'
    if (idx == 0) {
      this.popupDataTitle.title = type == 'EDIT' ? "Edit Effectiveness Check " + x : 'View Effectiveness Check ' + x;
      this.visibleAddButton = false;
      this.visibleEditButton = type == 'EDIT';
      this.operationFlag = type;
      this.previousData = ecActionRowData;
      this.previousDataEcId = ecActionRowData.EC_ID;
      this.previousDataActionEcId = ecActionRowData.ACTION_EC_ID;
      this.isProcessing = true;
      this.appService.getQmsTaskEcActionVwDetailsByOrgIdAndRefNoAnEcIdActionEcId(this.refNo, this.previousDataEcId, this.previousDataActionEcId).subscribe((response: any) => {
        this.getQmsTaskEcActionVwDetailData = response;
        this.ecActionsData.criteria = this.getQmsTaskEcActionVwDetailData.criteria;
        this.ecActionsData.conclusion = this.getQmsTaskEcActionVwDetailData.conclusion;
        if (this.getQmsTaskEcActionVwDetailData.actionId != null) {
          this.filteredActionValue = this.dropDownForActionName.filter((x: any) => x.actionId === this.getQmsTaskEcActionVwDetailData.actionId);
          if (this.filteredActionValue.length > 0) {
            this.selectedActionName = this.filteredActionValue[0].actionId
            /*  this.selectedActionName = [{
               valueExp: this.filteredActionValue[0].actionId,
               displayExp: this.filteredActionValue[0].actionName
             }] */
          }
        }
        if (this.getQmsTaskEcActionVwDetailData.methodology != null) {
          this.filteredMethodologyValue = this.dropDownDataForMethodology.filter((x: any) => x.codelistCode === this.getQmsTaskEcActionVwDetailData.methodology);
          if (this.filteredMethodologyValue.length > 0) {
            this.selectedMethodology = this.filteredMethodologyValue[0].codelistCode

          } else {
            this.selectedMethodology = this.getQmsTaskEcActionVwDetailData.methodology

          }
        }
        this.isProcessing = false;
        this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
      })
    }
  }

  openDeletePopup(ecActionRowData: any) {
    this.popupDataTitle.title = "Delete Effectiveness Check " + (this.message.ecMasterDetails.CHECK_REQD_FOR.includes('Pre') ? 'Preliminary ' : '') + 'Action';
    this.operationFlag = 'DELETE';
    this.previousData = ecActionRowData;
    this.previousDataEcId = ecActionRowData.EC_ID;
    this.previousDataActionEcId = ecActionRowData.ACTION_EC_ID;
    this.ecActionsData.deleteReason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  cancelAddAndEditPopup() {
    this.visibleAddAndEditPopup.close();
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  actionNameValueRequired: any;
  methodologyValueRequired: any;
  criteriaValueRequired: any;
  fieldValidation() {
    this.actionNameValueRequired = document.getElementById("actionName-validation") as HTMLInputElement;
    this.methodologyValueRequired = document.getElementById("methodology-validation") as HTMLInputElement;
    this.criteriaValueRequired = document.getElementById("criteria-validation") as HTMLInputElement;

    if (this.selectedActionName) {
      this.actionNameValueRequired.style.color = '';
    } else {
      this.actionNameValueRequired.style.color = 'red';
    }
    if (this.selectedMethodology) {
      this.methodologyValueRequired.style.color = '';
    } else {
      this.methodologyValueRequired.style.color = 'red';
    }

    if (this.ecActionsData.criteria == "") {
      this.criteriaValueRequired.style.color = 'red';
    } else {
      this.criteriaValueRequired.style.color = '';
    }
  }

  onFieldFocusout() {
    this.criteriaValueRequired = document.getElementById("criteria-validation") as HTMLInputElement;

    if (this.criteriaValueRequired != undefined) {
      if (this.ecActionsData.criteria == "" || this.ecActionsData.criteria == undefined) {
        this.criteriaValueRequired.style.color = 'red';
      } else {
        this.criteriaValueRequired.style.color = '';
      }
    }
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = (tempDiv.textContent ?? tempDiv.innerText) || '';
    return textContent.trim().length === 0;
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  addAndEditFunction(ecActionsData: any) {
    this.isProcessing = true;
    if (!this.selectedActionName || !this.selectedMethodology || this.ecActionsData.criteria == "" || (this.effectivenessCheckData.status == 'In Progress' && (!this.ecActionsData.conclusion || this.isContentEmpty(this.ecActionsData.conclusion)))) {
      alert('Please enter the all mandatory fields...');
      this.isProcessing = false;
      this.fieldValidation();
    } else if (this.operationFlag == "ADD") {
      this.isProcessing = true;
      ecActionsData.ecId = this.message.ecMasterDetails.EC_ID;
      ecActionsData.module = this.module;
      ecActionsData.refNo = this.refNo;
      ecActionsData.criteria = this.ecActionsData.criteria;
      ecActionsData.conclusion = this.ecActionsData.conclusion;
      ecActionsData.actionId = this.selectedActionName;
      ecActionsData.methodology = this.selectedMethodology;
      ecActionsData.isActionOrPreAction = this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items" ? 'Action' : 'PreAction'
      this.appService.createQmsTasksECAction(ecActionsData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      delete ecActionsData.createdOn;
      delete ecActionsData.updatedOn;
      this.isProcessing = true;
      ecActionsData.qmsTaskActionECVwPk = {
        actionEcId: this.previousDataActionEcId
      }
      ecActionsData.ecId = this.message.ecMasterDetails.EC_ID;
      ecActionsData.module = this.module;
      ecActionsData.refNo = this.refNo;
      ecActionsData.actionId = this.ecActionsData.ACTION_EC_ID;
      ecActionsData.criteria = this.ecActionsData.criteria;
      ecActionsData.conclusion = this.ecActionsData.conclusion;
      ecActionsData.actionId = this.selectedActionName;
      ecActionsData.methodology = this.selectedMethodology;
      ecActionsData.isActionOrPreAction = this.message.ecMasterDetails.CHECK_REQD_FOR == "Individual Action Items" ? 'Action' : 'PreAction'
      this.appService.updateQmsTasksECAction(ecActionsData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.isProcessing = false;
            this.getcallMethod();
          }
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  deleteReasonValue: any;
  deleteReasonRequiredMsg: any;
  deleteValidation() {
    this.deleteReasonValue = document.getElementById('deleteReason') as HTMLInputElement;
    this.deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;
    if (this.deleteReasonValue.value == '') {
      this.deleteReasonValue.style.border = '1px solid red';
      this.deleteReasonRequiredMsg.style.display = 'block';
    } else {
      this.deleteReasonValue.style.border = 'none';
      this.deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  deleteFunction(ecActionsData: any) {
    if (this.ecActionsData.deleteReason == "") {
      this.deleteValidation();
    } else {
      this.isProcessing = true;
      ecActionsData.qmsTaskActionECVwPk = {
        actionEcId: this.previousDataActionEcId
      }
      ecActionsData.ecId = this.message.ecMasterDetails.EC_ID;
      ecActionsData.deleteReason = this.ecActionsData.deleteReason;
      this.appService.deleteQmsTasksECAction(ecActionsData).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
          }
          this.isProcessing = false;
          this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          this.snackbarRef.onAction().subscribe(() => {
            this.snackbarRef.dismiss();
          });
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  idMapping: Record<string, string> = { 'CR': this.qmsservice.activity.crId, 'CAPA': this.qmsservice.activity.capaId, 'DV': this.qmsservice.activity.dvId, 'AU': this.qmsservice.activity.auId, 'IN': this.qmsservice.activity.inId, 'QI': this.qmsservice.activity.qiId, 'CC': this.qmsservice.activity.ccId };

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {};

  openAuditTrail(viewType: any, ec: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : ec.ACTION_EC_ID;
    this.auditTrail.activityRefNo = this.message.activityId;
    this.auditTrail.gridName = 'EC_ACTION';
    this.auditTrail.report_And_Popup_Name = this.qmsservice.moduleName + ' Effectiveness Check Audit Trail [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.dynamicAuditTrailComponent.triggerTrail(ec);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = { ...this.reportObj, excludeGroupId: true };
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' Effectiveness Check Report [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, this.qmsservice.moduleName, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  @ViewChild('viwerClobPopup', { static: true }) viwerClobPopup: TemplateRef<any>;
  visibleviwerClobPopup: MatDialogRef<TemplateRef<any>>;
  aviwerlPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: 'QMS_TASK_ACTION_EC_VW',
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error) => {
        throw error
      }
    })
    this.isProcessing = false;
  }

  htmlContent: any;
  closeHtmlContent() {
    this.visibleviwerClobPopup.close();
  }

  public getToolTip(mode: any): string {
    return mode + " Effectiveness Check " + (this.message.ecMasterDetails.CHECK_REQD_FOR.includes('Pre') ? 'Preliminary ' : '') + "Action";
  }

  public focusEmpty(): void { console.log(); }
}
